module.exports = __webpack_public_path__ + "img/1.02ef1397.png";